import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Link from '@mui/material/Link';
import { SvgIconProps } from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import React from 'react';

type ServiceCardProps = {
  bgColor: string;
  description: string;
  icon: React.ElementType<SvgIconProps>;
  iconColor: string;
  linkHref?: string;
  linkText: string;
  onLinkClick?: React.MouseEventHandler<HTMLElement>;
  phoneNumber?: string;
  title: string;
};

const ServiceCard: React.FC<ServiceCardProps> = ({
  bgColor,
  description,
  icon: Icon,
  iconColor,
  linkHref,
  linkText,
  onLinkClick,
  phoneNumber,
  title,
}) => {
  return (
    <Card
      elevation={0}
      sx={{
        '&:hover': {
          boxShadow: '0 8px 24px rgba(36, 26, 46, 0.12)',
          transform: 'translateY(-3px)',
        },
        alignItems: 'flex-start',
        border: '1px solid #E9E9EE',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(36, 26, 46, 0.08)',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 260,
        padding: '24px',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        width: '100%',
      }}>
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: bgColor,
          borderRadius: '10px',
          color: iconColor,
          display: 'flex',
          height: 48,
          justifyContent: 'center',
          marginBottom: '20px',
          width: 48,
        }}>
        <Icon sx={{ fontSize: 24 }} />
      </Box>

      <Typography
        sx={{
          color: '#111827',
          fontFamily: 'FiraSans-SemiBold',
          fontSize: '19px',
          lineHeight: '25px',
          marginBottom: '10px',
        }}>
        {title}
      </Typography>

      <Typography
        sx={{
          color: '#6B7280',
          fontFamily: 'FiraSans-Regular',
          fontSize: '15px',
          lineHeight: '22px',
          marginBottom: '10px',
        }}>
        {description}
      </Typography>

      <Link
        component={linkHref ? 'a' : 'button'}
        href={linkHref || undefined}
        onClick={linkHref ? undefined : onLinkClick}
        sx={{
          '&:hover': {
            opacity: 0.85,
            textDecoration: 'none',
          },
          alignItems: 'center',
          color: iconColor,
          display: 'inline-flex',
          fontFamily: 'FiraSans-SemiBold',
          fontSize: '15px',
          gap: '6px',
          textDecoration: 'none',
        }}
        underline="none">
        {linkText}
        <ArrowForwardIcon sx={{ fontSize: 18 }} />
        {phoneNumber}
      </Link>
    </Card>
  );
};

export default ServiceCard;
